import { type RegistryWidgetsType, type TemplatesType } from '@rjsf/utils'
import {
  CheckboxWidget,
  CurrencyWidget,
  RadioWidget,
  SelectWidget,
  TaxIdWidget,
  WizardArrayFieldTemplate,
  WizardBaseInputTemplate,
  WizardDescriptionFieldTemplate,
  WizardFieldTemplate,
  WizardObjectFieldTemplate,
  WizardTitleFieldTemplate,
} from './wizardRjsfWidgets'

export const WIZARD_WIDGETS: RegistryWidgetsType = {
  SelectWidget,
  RadioWidget,
  CheckboxWidget,
  CurrencyWidget,
  TaxIdWidget,
}

export const WIZARD_TEMPLATES: Partial<TemplatesType> = {
  BaseInputTemplate: WizardBaseInputTemplate,
  FieldTemplate: WizardFieldTemplate,
  ObjectFieldTemplate: WizardObjectFieldTemplate,
  ArrayFieldTemplate: WizardArrayFieldTemplate,
  TitleFieldTemplate: WizardTitleFieldTemplate,
  DescriptionFieldTemplate: WizardDescriptionFieldTemplate,
}
